import React, {useState, useEffect} from "react";
import {axiosInstance} from "../../../utils/axiosInstance"
import Loader from "react-spinners/PropagateLoader";
import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import {IoMdHome} from "react-icons/io";
import {IoDocuments} from "react-icons/io5";
import {MdBarChart, MdDashboard} from "react-icons/md";
import { Link } from "react-router-dom";
import {columnsDataCheck, columnsDataComplex} from "./variables/columnsData";

import Widget from "components/widget/Widget";
import DailyTraffic from "views/admin/default/components/DailyTraffic";
import TaskCard from "views/admin/default/components/TaskCard";
import tableDataCheck from "./variables/tableDataCheck.json";
import tableDataComplex from "./variables/tableDataComplex.json";
import {fetchAllNews} from "../../../services/news";
const Dashboard = () => {

    const [loading, setLoading] = useState(false);
    const [totalSaleData, setTotalSaleData] = useState([]);
    const [currentSaleData, setCurrentSaleData] = useState([]);
    const [totalPayment, setTotalPayment] = useState(0);
    const [totalSellCount, setTotalSellCount] = useState(0);
    const [totalUniqeUser, setTotalUniqeUser] = useState(0);
    const [currentMonthSale, setCurrentMonthSale] = useState(0);
    const [saleCount, setSaleCount] = useState(0);
    const [requestCount, setRequestCount] = useState(0);
    const [phonixSales, setPhonixSales] = useState([]);
    const [phonixShowFlag, setPhonixShowFlag] = useState(0);
    const [requestsPerMonth, setRequestsPerMonth] = useState([]);
    const [salePerMonth, setSalePerMonth] = useState([]);


    const totalSaleChartData = [
        {
            name: "میزان فروش",
            data: salePerMonth.map(item => item.sale),
            color: "#4318FF",
        },
    ];
    const TotalRequestChartData = [
        {
            name: "تعداد درخواست",
            data: requestsPerMonth.map(item => item.orderCount),
            color: "#6AD2FF",
        },
    ];


    const handlePhonixFlag = (event) => {
        const newValue = event.target.value;
        if (newValue === "total")
            setPhonixShowFlag(1);
        else if (newValue === "monthly")
            setPhonixShowFlag(0);
    };

    const calculatePhoniexSale = () => {
        let totalData = [];

        if (currentSaleData && currentSaleData.length !== 0 && phonixShowFlag === 0) {
            totalData.push(currentSaleData);
        } else {
            totalData = totalSaleData;
        }

        if (totalData.length === 0)
            return;
        const PhonixSaleData = totalData.map(item => item.productCounts)
        const flattenedData = PhonixSaleData.flat();

        // Step 2: Use reduce to accumulate counts
        const productCounts = flattenedData.reduce((acc, item) => {
            if (acc[item.productName]) {
                acc[item.productName] += item.productCount;
            } else {
                acc[item.productName] = item.productCount;
            }
            return acc;
        }, {});

        const result = Object.keys(productCounts).map(productName => ({
            productName,
            productCount: productCounts[productName]
        }));
        setPhonixSales(result);
    }


    const getSaleStatistics = async (year, month) => {
        try {
            const response = await axiosInstance.get('api/BusinessStatistics/SaleStatistics');
            const totalData = response.data;
            setTotalSaleData(totalData);
            const currentData = totalData.find(item => item.year === year && item.month === month);
            setCurrentSaleData(currentData);
            if (totalData) {
                let sum = 0;
                sum = totalData.reduce((acc, item) => acc + item.totalPayment, 0);
                setTotalPayment(sum)
                sum = totalData.reduce((acc, item) => acc + item.orderCount, 0);
                setTotalSellCount(sum)
                sum = totalData.reduce((acc, item) => acc + item.uniqueUserCount, 0);
                setTotalUniqeUser(sum)
                const TotalSaleData = totalData.map(item => {
                    return {
                        month: item.month + "/" + item.year,
                        sale: item.totalPayment
                    }
                })
                setSalePerMonth(TotalSaleData);
            }
            if (currentData) {
                setCurrentMonthSale(currentData.totalPayment);
            }


            setLoading(false);
        } catch (error) {
            console.error('Error fetching Sale Statistics:', error);
            setLoading(false);
        }
    }

    const getRequestStatistics = async () => {
        try {
            const response = await axiosInstance.get('api/BusinessStatistics/RequestStatistics');
            const totalData = response.data;
            if (totalData) {
                let sum = 0;
                sum = totalData.reduce((acc, item) => acc + item.orderCount, 0);
                setRequestCount(sum)
                const TotalRequestData = totalData.map(item => {
                    return {
                        month: item.month + "/" + item.year,
                        orderCount: item.orderCount
                    }
                });
                setRequestsPerMonth(TotalRequestData);
            }

            setLoading(false);
        } catch (error) {
            console.error('Error fetching Request Statistics:', error);
            setLoading(false);
        }
    }

    const [priorityNews, setPriorityNews] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1; // getMonth() returns 0-based month

            getSaleStatistics(year, month);
            getRequestStatistics();

        };

        const fetchNaftKhabarDashboardData = async () => {
            setLoading(true)
            const priorityNewsResponse = await fetchAllNews({ordering: 'priority'})
            setPriorityNews(priorityNewsResponse.data?.results)
            setLoading(false)
        }

        // fetchData();
        fetchNaftKhabarDashboardData()
    }, [])

    useEffect(() => {
        calculatePhoniexSale();
    }, [phonixShowFlag, totalSaleData])
    return (
        <div>
        
            {/* Card widget */}

            <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
            <div className="shadow-md rounded-lg p-6 bg-white space-y-4">
  <h2 className="text-lg font-bold text-gray-800">اخبار با اولویت</h2>
  <div className="space-y-3">
    {priorityNews.map((news) => (
      <Link
        key={news.id}
        to={`/admin/news/edit/${news.id}`}
        className="flex items-center space-x-3 p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition cursor-pointer"
      >
        <span className="bg-blueSecondary text-white rounded-md px-3 py-1 text-sm font-medium">
          {news.priority}
        </span>
        <span className="truncate text-gray-700">{news.title}</span>
      </Link>
    ))}
  </div>
</div>

                {/*<Widget*/}
                {/*  icon={<MdBarChart className="h-7 w-7" />}*/}
                {/*  title={"فروش کل"}*/}
                {/*  subtitle={totalPayment}*/}
                {/*  badge={"تومان"}*/}
                {/*/>*/}
                {/*<Widget*/}
                {/*  icon={<MdDashboard className="h-6 w-6" />}*/}
                {/*  title={"تعداد خرید کل"}*/}
                {/*  subtitle={totalSellCount}*/}
                {/*/>*/}
                {/*<Widget*/}
                {/*  icon={<MdBarChart className="h-7 w-7" />}*/}
                {/*  title={"تعداد درخواست محصولات"}*/}
                {/*  subtitle={requestCount}*/}
                {/*  badge={"{غیر از ققنوس}"}*/}
                {/*/>*/}
                {/*<Widget*/}
                {/*  icon={<IoMdHome className="h-6 w-6" />}*/}
                {/*  title={"فروش ماه جاری"}*/}
                {/*  subtitle={currentMonthSale}*/}
                {/*  badge={"تومان"}*/}
                {/*/>*/}
                {/*<Widget*/}
                {/*  icon={<MdBarChart className="h-7 w-7" />}*/}
                {/*  title={"بازدید از سایت"}*/}
                {/*  subtitle={"101"}*/}
                {/*  badge={"تومان"}*/}
                {/*/>*/}
                {/*<Widget*/}
                {/*  icon={<IoDocuments className="h-6 w-6" />}*/}
                {/*  title={"تعداد مشتریان منحصر به فرد"}*/}
                {/*  subtitle={totalUniqeUser}*/}
                {/*/>*/}


            </div>

            {/* Charts */}

            {/*<div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">*/}
            {/*  <TotalSpent nodeValues={totalSaleChartData} categories={salePerMonth.map(item => item.month)} />*/}
            {/*  <WeeklyRevenue nodeValues={TotalRequestChartData} categories={requestsPerMonth.map(item => item.month)} />*/}
            {/*</div>*/}

            {/* Tables & Charts */}

            {/*<div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">*/}

            {/* Traffic chart & Pie Chart */}
            {/*<DailyTraffic />*/}
            {/*<PieChartCard nodeValues={phonixSales.map(item => item.productCount)} categories={phonixSales.map(item => item.productName)} handlePhonixFlag={handlePhonixFlag} />*/}

            {/* Complex Table , Task & Calendar */}

            {/* <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        /> */}

            {/* Task chart & Calendar */}

            {/* <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <TaskCard />
          <div className="grid grid-cols-1 rounded-[20px]">
            <MiniCalendar />
          </div>
        </div> */}
            {/*</div>*/}
        </div>
    );
};

export default Dashboard;
